import { Routes } from '@angular/router';

import { locationsSegments } from '@advania-cosoftware/wolf-router';

export const locationsRoutes: Routes = [
    {
        path: locationsSegments.locations,
        loadComponent: () => import('./pages/locations-page/locations.page').then((m) => m.LocationsPage),
    },
    {
        path: `${locationsSegments.locations}/:locationId`,
        loadComponent: () => import('./pages/location-page/location.page').then((m) => m.LocationPage),
    },
];
